import { render, staticRenderFns } from "./MtoSectorsList.vue?vue&type=template&id=83b76610&scoped=true"
import script from "./MtoSectorsList.vue?vue&type=script&lang=js"
export * from "./MtoSectorsList.vue?vue&type=script&lang=js"
import style0 from "./MtoSectorsList.vue?vue&type=style&index=0&id=83b76610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b76610",
  null
  
)

export default component.exports